import {Button, Select, Space} from "antd";
import {DownOutlined, UpOutlined} from "@ant-design/icons";
import {useEffect, useState} from "react";
import HecRasHelper from "../../../helpers/HecRasHelper";

export default function ResultListBox({list, onChange, defaultValue, text, value, labelPositionTop, width, suffixIcon, otherData, filter, selectProps = {}}) {
    const [selected, setSelected] = useState(value || defaultValue)
    const [items, setItems] = useState([])

    // Highlight/Filter (result sayfasi toolbar'i). Aktif aralik varsa:
    //  - 'filter'    -> listeyi aralik ici RS'lerle sinirla
    //  - 'highlight' -> hepsi kalir, aralik ici RS'ler mavi vurgulanir (CheckCSName ile ayni)
    const hasRange = !!(filter && (filter.us || filter.ds))
    const inRange = (x) => HecRasHelper.inFilter({us: filter?.us, ds: filter?.ds, cs_name: x?.toString()})
    const uniqueItems = Array.from(new Set(items))
    const displayItems = (hasRange && filter?.type === 'filter')
        ? uniqueItems.filter(inRange)
        : uniqueItems

    const onPrev = () => {
        const index = displayItems?.findIndex(x => x === selected)
        if(index > 0) {
            setSelected(displayItems[index-1])
        }
    }
    const onNext = () => {
        const index = displayItems?.findIndex(x => x === selected)
        if(index < displayItems?.length-1) {
            setSelected(displayItems[index+1])
        }
    }

    const renderList = () => {
        return displayItems.map(x => {
            const highlight = hasRange && filter?.type === 'highlight' && inRange(x)
            return (
                <Select.Option value={x} key={x}>
                    {highlight
                        ? <span style={{backgroundColor: '#91d5ff', padding: '0 4px', borderRadius: 2}}>{x}</span>
                        : x}
                </Select.Option>
            )
        })
    }

    useEffect(() => {
        if(selected && selected !== value) {
            onChange && onChange(selected)
        }
    }, [selected]);

    useEffect(() => {
        if(value !== selected)
            setSelected(value)
    }, [value])

    useEffect(() => {
        setItems(Array.from(new Set(list)))
    }, [list])

    return (
        <div style={{display: 'flex', alignItems: labelPositionTop ? 'start' : 'center', flexDirection: labelPositionTop ? 'column' : 'row'}}>
            <label>
                {text}
            </label>
            <Space size={0}>
                <Select
                    suffixIcon={suffixIcon}
                    style={{width: width || 200}}
                    value={selected}
                    onChange={(val) => {setSelected(val)}}
                    size={'small'}
                    {...selectProps}
                >
                    {renderList()}
                </Select>
                <Button disabled={displayItems?.findIndex(x => x === selected) === 0} onClick={onPrev} size={'small'} icon={<UpOutlined />} />
                <Button disabled={displayItems?.findIndex(x => x === selected) === displayItems?.length-1} onClick={onNext} size={'small'} icon={<DownOutlined />} />
            </Space>
        </div>
    )
}